import './StudentVoice.css'

const StudentVoice = () => {
    return (
        <>
            <div className="video-container">
                <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/vUyaMUzjtDU"
                    title="Student Voice Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
            <div className="video-container">
                <iframe
                    width="100%"
                    height="315"
                    src="https://www.youtube.com/embed/MAEf4inbIcM"
                    title="Student Voice Video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                ></iframe>
            </div>
        </>
    )
}

export default StudentVoice